export const lenderAchInformationArr = [
  {
    field: "general",
    arr: [
      {
        section: "Name & Salutation",
        className: "col-6",
        arr: [
          {
            title: "Co. Name",
            field: "name",
            type: "text",
            className: "col-12",
          },
          {
            title: "Salutation",
            field: "salutation",
            type: "text",
            className: "col-12",
          },
          {
            title: "First Name",
            field: "firstName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Last Name",
            field: "lastName",
            type: "text",
            className: "col-12",
          },
          {
            title: "M.I.",
            field: "middleInitial",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Mailing Address",
        className: "col-6",
        arr: [
          {
            title: "Street",
            field: "street",
            type: "text",
            className: "col-12",
          },
          {
            title: "City",
            field: "city",
            type: "text",
            className: "col-12",
          },
          {
            title: "State",
            field: "state",
            type: "select",
            className: "col-12",
            options: [{ label: "TX", value: "TX" }],
          },
          {
            title: "Zip Code",
            field: "zipCode",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Email",
        className: "col-6",
        arr: [
          {
            title: "E-mail",
            field: "email",
            type: "text",
            className: "col-12",
          },
          // {
          //   title: "Format",
          //   field: "emailFormat",
          //   type: "select",
          //   className: "col-12",
          //   options: [
          //     { label: "Plain Text", value: "0" },
          //     { label: "HTML", value: "1" },
          //   ],
          // },
          // {
          //   content: <p className="fw-bold">Delivery</p>,
          //   type: "content",
          //   className: "col-12",
          // },
          // {
          //   title: "Print",
          //   field: "email_print_delivery",
          //   type: "checkbox",
          //   className: "col-4",
          // },
          // {
          //   title: "Email",
          //   field: "email_email_delivery",
          //   type: "checkbox",
          //   className: "col-4",
          // },
          // {
          //   title: "Print",
          //   field: "email_textMessage_delivery",
          //   type: "checkbox",
          //   className: "col-4",
          // },
        ],
      },
      {
        section: "Phone Numbers",
        className: "col-6",
        arr: [
          {
            title: "Home",
            field: "homePhone",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Work",
            field: "workPhone",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Mobile",
            field: "mobilePhone",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Fax",
            field: "faxNumber",
            type: "phoneNumber",
            className: "col-12",
          },
        ],
      },
      // {
      //   section: "Account Information",
      //   className: "col-6",
      //   arr: [
      //     // {
      //     //   title: "Account",
      //     //   field: "account",
      //     //   type: "text",
      //     //   className: "col-12",
      //     // },
      //     {
      //       title: "TIN",
      //       field: "taxIdentificationNumber",
      //       type: "text",
      //       className: "col-12",
      //     },
      //     {
      //       title: "TIN Type",
      //       field: "taxIdType",
      //       type: "select",
      //       className: "col-12",
      //       options: [
      //         // { label: "0-Unknown", value: "0" },
      //         { label: "2-SSN", value: "2" },
      //         { label: "1-EIN", value: "3" },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   section: "Notices & Forms",
      //   className: "col-6",
      //   arr: [
      //     {
      //       title: "Tax Reporting",
      //       field: "taxReporting",
      //       type: "checkbox",
      //       className: "col-12",
      //     },
      //     {
      //       title: "Print Rolodex Cards",
      //       field: "printRolodexCards",
      //       type: "checkbox",
      //       className: "col-12",
      //     },
      //   ],
      // },
      // {
      //   section: "Personal",
      //   className: "col-6",
      //   arr: [
      //     {
      //       title: "Birthday",
      //       field: "birthday",
      //       type: "text",
      //       className: "col-12",
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   field: "details",
  //   arr: [
  //     {
  //       section: "Categories & Grouping",
  //       className: "col-6",
  //       arr: [
  //         {
  //           title: "Lender Code",
  //           field: "lenderCode",
  //           type: "text",
  //           className: "col-12",
  //         },
  //         {
  //           title: "Counselor",
  //           field: "counselor",
  //           type: "select",
  //           className: "col-12",
  //           options: [
  //             { label: "Active", value: "Active" },
  //             // Add additional options here as needed
  //           ],
  //         },
  //         {
  //           title: "Categories",
  //           field: "categories",
  //           type: "text",
  //           className: "col-12",
  //         },
  //         {
  //           title: "Send Check to Payee",
  //           field: "sendCheckToPayeeCheckbox",
  //           type: "checkbox",
  //           className: "col-12",
  //         },
  //         {
  //           title: "Send Check to Payee",
  //           field: "sendCheckToPayeeMessage",
  //           type: "textarea",
  //           className: "col-12",
  //         },
  //       ],
  //     },
  //     {
  //       section: "Accounting System Integration",
  //       className: "col-6",
  //       arr: [
  //         {
  //           title: "Methodology",
  //           field: "methodology",
  //           type: "select",
  //           className: "col-12",
  //           options: [
  //             { label: "Lender Account", value: "LenderAccount" },
  //             // Add additional options here as needed
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       section: "Institutional Lender (CA RE 881)",
  //       className: "col-6",
  //       arr: [
  //         {
  //           title: "Institutional Lender (CA RE 881)",
  //           field: "institutionalLender",
  //           type: "checkbox",
  //           className: "col-12",
  //         },
  //         {
  //           content: <p className="fw-bold">Loan Types</p>,
  //           type: "content",
  //           className: "col-4",
  //         },
  //         {
  //           title: "Fixed",
  //           field: "loanTypes_fixed",
  //           type: "checkbox",
  //           className: "col-4",
  //         },
  //         {
  //           title: "Adjustable",
  //           field: "loanTypes_adjustable",
  //           type: "checkbox",
  //           className: "col-4",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   field: "ach",
  //   arr: [
  //     {
  //       section: "ACH Information",
  //       className: "col-12",
  //       // className: "col-12",
  //       arr: [
  //         {
  //           title: "Bank Name",
  //           field: "bankName",
  //           type: "text",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Bank Address",
  //           field: "bankAddress",
  //           type: "textarea",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Routing Number",
  //           field: "routingNumber",
  //           type: "text",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Account Number",
  //           field: "accountNumber",
  //           type: "text",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Individual Id",
  //           field: "individualId",
  //           type: "text",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Individual Name",
  //           field: "individualName",
  //           type: "text",
  //           className: "col-6",
  //         },
  //         {
  //           title: "Account Type",
  //           field: "accountType",
  //           type: "select",
  //           className: "col-6",
  //           options: [
  //             { label: "Checking", value: 0 },
  //             { label: "Savings", value: 1 },
  //             { label: "GL Deposite (Credit)", value: 2 },
  //             // Additional options can be added as necessary
  //           ],
  //         },
  //         {
  //           title: "Service Status",
  //           field: "serviceStatus",
  //           type: "select",
  //           className: "col-12",
  //           options: [
  //             { label: "None", value: 0 },
  //             { label: "Active", value: 1 },
  //             { label: "Cancelled", value: 2 },
  //             { label: "Hold", value: 3 },
  //             // Additional options can be added as necessary
  //           ],
  //         },
  //         {
  //           title: "Send Printed Notification of Deposit",
  //           field: "sendPrintedNotification",
  //           type: "checkbox",
  //           className: "col-12",
  //         },
  //         {
  //           title: "Send Email Notification of Deposit",
  //           field: "sendEmailNotification",
  //           type: "checkbox",
  //           className: "col-12",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const lenderAchInformationProfilePageArr = (
  canEdit = false,
  tinType = 0,
  role = ""
) => {
  return [
    {
      field: "general",
      arr: [
        {
          section: "Name & Salutation",
          className: "col-6",
          arr: [
            {
              title: "Name",
              field: "FullName",
              type: "text",
              className: "col-12",
              disable: true,
              blur: true
            },
            {
              title: "Salutation",
              field: "Salutation",
              type: "text",
              className: "col-4",
              disable: true,
              blur: true
            },
            {
              title: "First Name",
              field: "FirstName",
              type: "text",
              className: "col-8",
              disable: true,
              blur: true
            },
            {
              title: "Last Name",
              field: "LastName",
              type: "text",
              className: "col-8",
              disable: true,
              blur: true
            },
            {
              title: "M.I.",
              field: "MI",
              type: "text",
              className: "col-4",
              disable: true,
              blur: true
            },
          ],
        },
        {
          section: "Mailing Address",
          className: "col-6",
          arr: [
            {
              title: "Street",
              field: "Street",
              type: "text",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
            {
              title: "City",
              field: "City",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "State",
              field: "State",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Zip Code",
              field: "ZipCode",
              type: "text",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
          ],
        },
        {
          section: "Email",
          className: "col-6",
          arr: [
            {
              title: "E-mail",
              field: "EmailAddress",
              type: "text",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
            // {
            //   title: "Format",
            //   field: "EmailFormat",
            //   type: "select",
            //   className: "col-12",
            //   options: [
            //     { label: "Plain Text", value: "0" },
            //     { label: "HTML", value: "1" },
            //   ],
            // },
            // DeliveryOptions todo
            // {
            //   content: <p className="fw-bold">Delivery</p>,
            //   type: "content",
            //   className: "col-12",
            // },
            // {
            //   title: "Print",
            //   field: "email_print_delivery",
            //   type: "checkbox",
            //   className: "col-4",
            // },
            // {
            //   title: "Email",
            //   field: "email_email_delivery",
            //   type: "checkbox",
            //   className: "col-4",
            // },
            // {
            //   title: "Text",
            //   field: "email_textMessage_delivery",
            //   type: "checkbox",
            //   className: "col-4",
            // },
          ],
        },
        {
          section: "Phone Numbers",
          className: "col-6",
          arr: [
            {
              title: "Home",
              field: "PhoneHome",
              type: "phoneNumber",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Work",
              field: "PhoneWork",
              type: "phoneNumber",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Mobile",
              field: "PhoneCell",
              type: "phoneNumber",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Fax",
              field: "PhoneFax",
              type: "phoneNumber",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
          ],
        },
        {
          section: "Account Information",
          className: "col-6",
          arr: [
            // {
            //   title: "Account",
            //   field: "Account",
            //   type: "text",
            //   className: "col-12",
            // },
            {
              title: "TIN",
              field: "TIN",
              type: "pattern",
              className: "col-12",
              disable: !canEdit,
              pattern:
                tinType === 0
                  ? "000000000"
                  : tinType === 2
                  ? "000-00-0000"
                  : "12-3456789",
                  blur: true
            },
            {
              title: "TIN Type",
              field: "TINType",
              type: "select",
              className: "col-12",
              options: [
                { label: "0-Unknown", value: 0 },
                { label: "2-SSN", value: 2 },
                { label: "1-EIN", value: 3 },
              ],
              disable: !canEdit,
              blur: true
            },
          ],
        },
        // {
        //   section: "Notices & Forms",
        //   className: "col-6",
        //   arr: [
        //     {
        //       title: "Tax Reporting",
        //       field: "taxReporting",
        //       type: "checkbox",
        //       className: "col-12",
        //     },
        //     {
        //       title: "Print Rolodex Cards",
        //       field: "printRolodexCards",
        //       type: "checkbox",
        //       className: "col-12",
        //     },
        //   ],
        // },
        {
          section: "Personal",
          className: "col-6",
          arr: [
            {
              title: "Birthday",
              field: "Birthday",
              type: "date",
              className: "col-12",
              disable: !canEdit,
              blur: true
            },
          ],
        },
      ],
    },
    // {
    //   field: "details",
    //   arr: [
    //     {
    //       section: "Categories & Grouping",
    //       className: "col-6",
    //       arr: [
    //         {
    //           title: "Lender Code",
    //           field: "Code",
    //           type: "text",
    //           className: "col-12",
    //         },
    //         {
    //           title: "Counselor",
    //           field: "Counselor",
    //           type: "select",
    //           className: "col-12",
    //           options: [
    //             { label: "Active", value: "Active" },
    //             // Add additional options here as needed
    //           ],
    //         },
    //         {
    //           title: "Categories",
    //           field: "Categories",
    //           type: "text",
    //           className: "col-12",
    //         },
    //         {
    //           title: "Send Check to Payee",
    //           field: "Send1099",
    //           type: "checkbox",
    //           className: "col-12",
    //         },
    //         {
    //           title: "Send Check to Payee",
    //           field: "sendCheckToPayeeMessage",
    //           type: "textarea",
    //           className: "col-12",
    //         },
    //       ],
    //     },
    //     {
    //       section: "Accounting System Integration",
    //       className: "col-6",
    //       arr: [
    //         {
    //           title: "Methodology",
    //           field: "methodology",
    //           type: "select",
    //           className: "col-12",
    //           options: [
    //             { label: "Lender Account", value: "LenderAccount" },
    //             // Add additional options here as needed
    //           ],
    //         },
    //       ],
    //     },
    //     {
    //       section: "Institutional Lender (CA RE 881)",
    //       className: "col-6",
    //       arr: [
    //         {
    //           title: "Institutional Lender (CA RE 881)",
    //           field: "Institutional",
    //           type: "checkbox",
    //           className: "col-12",
    //         },
    //         // {
    //         //   content: <p className="fw-bold">Loan Types</p>,
    //         //   type: "content",
    //         //   className: "col-4",
    //         // },
    //         // {
    //         //   title: "Fixed",
    //         //   field: "LoanType_Fixed",
    //         //   type: "checkbox",
    //         //   className: "col-4",
    //         // },
    //         // {
    //         //   title: "Adjustable",
    //         //   field: "LoanType_Adjustable",
    //         //   type: "checkbox",
    //         //   className: "col-4",
    //         // },
    //       ],
    //     },
    //   ],
    // },
    {
      field: "ach",
      arr: [
        {
          section: "ACH Information",
          className: "col-12",
          // className: "col-12",
          arr: [
            {
              title: "Bank Name",
              field: "ACH_BankName",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              display: role?.includes("Borrower") ? "hidden" : "",
              blur: true
            },
            {
              title: "Bank Address",
              field: "ACH_BankAddress",
              type: "textarea",
              className: "col-6",
              disable: !canEdit,
              display: role?.includes("Borrower") ? "hidden" : "",
              blur: true
            },
            {
              title: "Routing Number",
              field: "ACH_RoutingNumber",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Account Number",
              field: "ACH_AccountNumber",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Individual Id",
              field: "ACH_IndividualId",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Individual Name",
              field: "ACH_IndividualName",
              type: "text",
              className: "col-6",
              disable: !canEdit,
              blur: true
            },
            {
              title: "Account Type",
              field: "ACH_AccountType",
              type: "select",
              className: "col-6",
              options: [
                { label: "Checking", value: 0 },
                { label: "Savings", value: 1 },
                { label: "GL Deposite (Credit)", value: 2 },
                // Additional options can be added as necessary
              ],
              disable: !canEdit,
              blur: true
            },
            {
              title: "Service Status",
              field: "ACH_ServiceStatus",
              type: "select",
              className: "col-6",
              options: [
                { label: "None", value: 0 },
                { label: "Active", value: 1 },
                { label: "Cancelled", value: 2 },
                { label: "Hold", value: 3 },
                // Additional options can be added as necessary
              ],
              disable: !canEdit,
              blur: true
            },
            // {
            //   title: "Send Printed Notification of Deposit",
            //   field: "sendPrintedNotification",
            //   type: "checkbox",
            //   className: "col-12",
            // },
            // {
            //   title: "Send Email Notification of Deposit",
            //   field: "sendEmailNotification",
            //   type: "checkbox",
            //   className: "col-12",
            // },
          ],
        },
      ],
    },
  ];
};
